<template>
  <!-- Pre-program content -->
  <main role="main" class="container">
    <div class="text-center py-md-5 px-md-4 py-3">
      <div class="text-block text-center position-relative">
        <h1 class="page-heading">{{ $t('PreProgram.SplashTitle') }}</h1>
      </div>
      <p v-html="$t('PreProgram.SplashDescription')" class="page-subheader"></p>
      <p class="my-5 text-center">
        <a href="https://www.frostedflakes.us/mission-tiger/ " target="_blank" class="btn-link">VISIT MISSION TIGER</a>
      </p>
    </div>
  </main>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
  },
};
</script>
<style scoped>

</style>
